import {Pipe, PipeTransform} from '@angular/core';
import {formatBytes, formatDuration, formatMs, relativeDay} from './format';

@Pipe({
    name: 'formatMs'
})
export class FormatMsPipe implements PipeTransform {
    transform(value: number | string | null | undefined): string {
        return formatMs(value);
    }
}

@Pipe({
    name: 'formatBytes'
})
export class FormatBytesPipe implements PipeTransform {
    transform(value: number | string | null | undefined): string {
        return formatBytes(value);
    }
}

/** Minutes as "h:mm". */
@Pipe({
    name: 'formatDuration'
})
export class FormatDurationPipe implements PipeTransform {
    transform(value: number | string | null | undefined): string {
        return formatDuration(value);
    }
}

@Pipe({
    name: 'relativeDay'
})
export class RelativeDayPipe implements PipeTransform {
    transform(value: Date | string | null | undefined): string {
        return relativeDay(value);
    }
}
